import "./Profile.css";

import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

import AppBar from "@mui/material/AppBar";
import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import CssBaseline from "@mui/material/CssBaseline";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import MenuIcon from "@mui/icons-material/Menu";
import { PAGES } from "../constants";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import SettingsIcon from "@mui/icons-material/Settings";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";

const drawerWidth = 240;
const menuItems = {
  0: {
    path: PAGES.PROFILE_OVERVIEW,
    name: "Overview",
  },
  1: {
    path: PAGES.PROFILE_SUBSCRIPTIONS,
    name: "Subscriptions",
  },
  2: {
    path: PAGES.PROFILE_SETTINGS,
    name: "Settings",
  },
}


function Profile(props) {
  const location = useLocation();
  const navigate = useNavigate();

  const { window } = props;

  const [mobileOpen, setMobileOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  useEffect(() => {
    const path = location.pathname;
    const index = Object.keys(menuItems).findIndex(key => menuItems[key].path === path);
    setSelectedItem(index);
  }, [location]);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleListItemClick = (event, index) => {
    navigate(menuItems[index].path);
    // setSelectedItem(index);
  };

  const drawer = (
    <div>
      <Avatar
        sx={{
          width: 100,
          height: 100,
          margin: "1rem auto",
        }}
      />
      <Divider />
      <List>
        <ListItem key={menuItems[0].name} disablePadding>
          <ListItemButton selected={selectedItem === 0} onClick={(event) => handleListItemClick(event, 0)}>
            <ListItemIcon>
              <PersonOutlineOutlinedIcon />
            </ListItemIcon>
            <ListItemText primary={menuItems[0].name} />
          </ListItemButton>
        </ListItem>
        <ListItem key={menuItems[1].name} disablePadding>
          <ListItemButton selected={selectedItem === 1} onClick={(event) => handleListItemClick(event, 1)}>
            <ListItemIcon>
              <CreditCardIcon />
            </ListItemIcon>
            <ListItemText primary={menuItems[1].name} />
          </ListItemButton>
        </ListItem>
        <ListItem key={menuItems[2].name} disablePadding>
          <ListItemButton selected={selectedItem === 2} onClick={(event) => handleListItemClick(event, 2)}>
            <ListItemIcon>
              <SettingsIcon />
            </ListItemIcon>
            <ListItemText primary={menuItems[2].name} />
          </ListItemButton>
        </ListItem>
      </List>
    </div>
  );

  const container = window !== undefined ? () => window().document.body : undefined;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", sm: "row" }
      }}>
      <CssBaseline />
      <AppBar
        position="sticky"
        sx={{
          display: { sm: "none" }
        }}
      >
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { sm: "none" } }}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" noWrap component="div">
            {menuItems[selectedItem] ? menuItems[selectedItem].name : ""}
          </Typography>
        </Toolbar>
      </AppBar>
      <Box
        component="nav"
        sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
        aria-label="mailbox folders"
      >
        {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: "block", sm: "none" },
            "& .MuiDrawer-paper": { boxSizing: "border-box", width: drawerWidth },
          }}
        >
          {drawer}
        </Drawer>
        <Drawer
          variant="permanent"
          sx={{
            display: { xs: "none", sm: "block" },
            height: "100%",
            "& .MuiDrawer-paper": { boxSizing: "border-box", width: drawerWidth, position: "relative" },
          }}
          open
        >
          {drawer}
        </Drawer>
      </Box>
      <Box
        component="main"
        sx={{ flexGrow: 1, p: 3, width: { xs: "100vw", sm: `calc(100vw - ${drawerWidth}px)` } }}
      >
        <Outlet />
      </Box>
    </Box>
  );
}

export default Profile;